import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { AlertTriangle } from 'lucide-react';
export function UrgencySection() {
  return <section className="px-6 py-5 max-w-3xl mx-auto" data-id="element-551">
      <FadeIn data-id="element-552">
        <div className="bg-[#9B4F2B]/10 border border-[#9B4F2B]/30 rounded-2xl p-6 md:p-8 mb-8 flex gap-4 items-start" data-id="element-553">
          <AlertTriangle className="text-[#9B4F2B] shrink-0 mt-1" size={28} data-id="element-554" />
          <div data-id="element-555">
            <p className="font-bold text-[#9B4F2B] text-lg mb-2" data-id="element-556">
              PRECIO DE LANZAMIENTO:
            </p>
            <p className="text-[#2D2A26] leading-relaxed" data-id="element-557">
              $6.39 USD es el precio de introducción. El objetivo es que
              cualquier mujer que lo necesite pueda probar el protocolo sin
              pensarlo demasiado. Pero este precio no será permanente. Una vez
              que termine el lanzamiento, el acceso al protocolo pasará a su
              precio normal de $17 USD.
            </p>
          </div>
        </div>

        <div className="space-y-6 text-lg md:text-xl text-center text-[#2D2A26] leading-relaxed" data-id="element-558">
          <p className="font-bold text-2xl mb-6" data-id="element-559">
            Hoy puedes acceder por $6.39 USD
          </p>

          <p className="font-bold text-[#4A5D3A] text-xl md:text-2xl" data-id="element-560">
            Menos que un café. Pero puede cambiar cómo descansa tu mente esta
            misma noche.
          </p>
        </div>
      </FadeIn>
    </section>;
}